import { useCallback } from 'react'

export function useActions(setView: (view: 'default' | 'delete') => void) {
  const onDelete = useCallback(() => setView('delete'), [setView])

  return {
    onDelete,
  }
}
